"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ua_1 = require("./ua");
var shared_1 = require("../constants/platform/shared");
function get2ndType() {
    var ua = ua_1.default();
    var secondType = '';
    var matchInfo = ua.match(shared_1.secondTypeReg);
    if (matchInfo && matchInfo[1]) {
        secondType = matchInfo[1];
    }
    return secondType;
}
exports.default = get2ndType;
